import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import BuildingMaterialContent from './BuildingMaterialContent';
import BuildingMaterialTypeModal from '../modals/BuildingMaterialTypeModal';

const form = {
  keyword: '',
};

function BuildingMaterialContainer({
  match,
  history,
  getBuildingMaterialTypeList,
  materialTypesList,
  isLoading,
  removeBuildingMaterialType,
  materialTypesListPager,
  getSingleMaterialType,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddMaterialTypeModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingMaterialTypeModal type="NEW" />,
      title: 'Add Building Material Type',
      modalSize: 'modal-md',
    });
  };

  const handleEditMaterialTypeModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingMaterialTypeModal type="EDIT" dataInfo={data.attributes} id={data.id} />,
      title: 'Update Building Material Type',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveMaterialTypeModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this building material type?',
      () => {
        removeBuildingMaterialType(data.id, () => {
          getBuildingMaterialTypeList();
          const id = _.get(materialTypesList, '0.id');
          history.push(
            `/rpt/building/settings/building-materials/${id}`
          );
          getSingleMaterialType(id);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getBuildingMaterialTypeList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getBuildingMaterialTypeList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:materialTypeId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Building Material Type"
            getData={getBuildingMaterialTypeList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:materialTypeId?`}
            listName="classificationCodes"
            label="Building Material Types"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            noRightCard
            isLoading={isLoading}
            selected={params.materialTypeId}
            data={materialTypesList}
            dataPager={materialTypesListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:materialTypeId?`}
                    render={() => (
                      <BuildingMaterialContent
                        handleAddMaterialTypeModal={handleAddMaterialTypeModal}
                        handleEditMaterialTypeModal={handleEditMaterialTypeModal}
                        handleRemoveMaterialTypeModal={handleRemoveMaterialTypeModal}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:materialTypeId?`}
                  render={() =>
                    !params.materialTypeId && materialTypesList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(materialTypesList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BuildingMaterialContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBuildingMaterialTypeList: PropTypes.instanceOf(Function).isRequired,
  materialTypesList: PropTypes.instanceOf(Array).isRequired,
  materialTypesListPager: PropTypes.instanceOf(Object).isRequired,
  removeBuildingMaterialType: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleMaterialType: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  materialTypesList: _.get(api, `${c.GET_BUILDING_MATERIAL_TYPE}.list`) || [],
  materialTypesListPager: _.get(api, `${c.GET_BUILDING_MATERIAL_TYPE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BUILDING_MATERIAL_TYPE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingMaterialContainer);
